export const PerkStar = (props: any) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 0C6 0 6.41976 3.02564 7.69706 4.30294C8.97436 5.58024 12 6 12 6C12 6 8.97436 6.41976 7.69706 7.69706C6.41976 8.97436 6 12 6 12C6 12 5.58024 8.97436 4.30294 7.69706C3.02564 6.41976 0 6 0 6C0 6 3.02564 5.58024 4.30294 4.30294C5.58024 3.02564 6 0 6 0Z" fill="#CBBAE9" />
  </svg>
)
